module.exports = __webpack_public_path__ + "img/class.007a437d.png";